import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { getCloudinaryCoverUrl, getBookFallbackColor } from "../../../utils";

import styles from "./BookCard.module.scss";



const BookCard = ({
  book: { title, image, fields, shortDescription, slug, fileUrl },
  parentPath,
}) => {
  const {
    i18n: { language },
  } = useTranslation();
  const [flipped, setFlipped] = useState(false);
  const navigate = useNavigate();

  const [imgSrc, setImgSrc] = useState(
    image && image !== "null" ? image : getCloudinaryCoverUrl(fileUrl) || ""
  );

  useEffect(() => {
    setImgSrc(image && image !== "null" ? image : getCloudinaryCoverUrl(fileUrl) || "");
  }, [image, fileUrl]);

  const FlipIcon = () => (
    <img
      src={process.env.PUBLIC_URL + "/assets/icons/flip-icon.png"}
      alt="Flip Icon"
      className={styles.flipIcon}
      onClick={(e) => {
        e.stopPropagation();
        setFlipped(!flipped);
      }}
    />
  );

  return (
    <div
      className={styles.card}
      onClick={() => {
        navigate(`/${parentPath}/${slug}`);
      }}
    >
      <div className={`${styles.cardInner} ${parentPath === "article" ? styles.articleCardInner : styles.bookCardInner} ${flipped ? styles.flipped : ""}`}>
        <div className={`${styles.cardFront}`}>
          {imgSrc ? (
            <img
              src={imgSrc}
              alt={title?.[language] ? title?.[language] : ""}
              loading="lazy"
              onError={() => {
                const pdfBackup = getCloudinaryCoverUrl(fileUrl);
                if (pdfBackup && imgSrc !== pdfBackup) {
                  setImgSrc(pdfBackup);
                } else {
                  setImgSrc(""); // Trigger fallback rendering
                }
              }}
            />
          ) : (
            <div
              className={parentPath === "article" ? styles.articleFallbackCover : styles.fallbackCover}
              style={
                parentPath === "article"
                  ? {}
                  : {
                      backgroundColor: getBookFallbackColor(
                        title?.[language] || title?.en || ""
                      ),
                    }
              }
            >
              <div className={styles.fallbackIcon}>
                {parentPath === "article" ? "📜" : "📖"}
              </div>
              <span className={styles.fallbackText}>{title?.[language] || title?.en || ""}</span>
            </div>
          )}
          <FlipIcon />
        </div>
        <div className={styles.cardBack}>
          {/* TODO: Uncomment when download functionality is done */}
          {/* <div className={styles.cardBackAcion}>
            {fileUrl ? (
              <button
                className={styles.downloadButton}
                onClick={async () => {
                  if (fileUrl) {
                    try {
                      const response = await fetch(fileUrl);
                      if (!response.ok) {
                        throw new Error("Failed to download file");
                      }
                      const blob = await response.blob();
                      const link = document.createElement("a");
                      link.href = window.URL.createObjectURL(blob);
                      link.download = fileUrl.split("/").pop();
                      link.click();
                      window.URL.revokeObjectURL(link.href);
                    } catch (error) {
                      console.error("Error downloading the file:", error);
                    }
                  }
                }}
                download
              >
                <FileDownloadSharp />
              </button>
            ) : null}
          </div> */}
          <div className={styles.cardBackContent}>
            {fields?.map(({ label, value }, index) => (
              <p key={index}>
                <strong>{label?.[language]}</strong>
                <span>
                  {typeof value === "object"
                    ? value?.length
                      ? value
                          ?.map((item) =>
                            item?.[language] ? item?.[language] : ""
                          )
                          ?.join(", ")
                      : "—"
                    : value
                    ? value
                    : "—"}
                </span>
              </p>
            ))}
          </div>
          <FlipIcon />
        </div>
      </div>
      {/* <Link to={`/${parentPath}/${slug}`} className={styles.link}> */}
      <div className={styles.labelContainer}>
        <h3>{title?.[language] ? title?.[language] : ""}</h3>
        <p>
          {shortDescription?.[language] ? shortDescription?.[language] : ""}
        </p>
      </div>
      {/* </Link> */}
    </div>
  );
};

export default BookCard;
